export default {
  'quickLinks.heading': 'Quick Links',
  'quickLinks.label.viewAccountBalances': 'View Account Balances',
  'quickLinks.label.initiateTransfer': 'Initiate Transfer',
  'quickLinks.label.viewTransferActivity': 'View Transfer Activity',
  'quickLinks.label.viewPaymentActivity': 'View Payment Activity',
  'quickLinks.label.depositCheck': 'Deposit Check'
};
